// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Lz8M","selected":"styles_selected__21aAV"};